import { useTourFiltersStore } from '@/entities/filter/store/tour';
import { useFormatTypes } from '../useFormatTypes';
import type ru from '../../i18n/ru.json';
import { useComponentI18n } from '@/shared/composables/useComponentI18n';

type TSchema = typeof ru;

export function useFilterTourFormatTitle(messages: TSchema) {
  const { t } = useComponentI18n({ ru: messages });

  const filterStore = useTourFiltersStore();

  const { TOUR_FORMAT_AVAILABLE, tourTypesAvailable } = useFormatTypes(messages);

  function getDefaultTitle() {
    return t('format.title');
  }

  function setCurrentEndOfLabel(label: string) {
    if (label === TOUR_FORMAT_AVAILABLE.INDIVIDUAL.label) {
      return t('format.individual.plural');
    }

    if (label === TOUR_FORMAT_AVAILABLE.GROUP.label) {
      return t('format.group.plural');
    }

    return t('format.minigroup.plural');
  }

  const title = computed(() => {
    const selected = filterStore.searchState.tourFormat;

    if (!selected.length) {
      return getDefaultTitle();
    }

    return tourTypesAvailable
      .reduce((acc, item) => {
        if (selected.includes(item.value)) {
          acc.push(acc.length ? setCurrentEndOfLabel(item.label).toLowerCase() : setCurrentEndOfLabel(item.label));
        }

        return acc;
      }, [] as string[])
      .join(', ');
  });

  const itemsCount = computed(() => filterStore.searchState.tourFormat.length);

  const isActive = computed(() => title.value !== getDefaultTitle());

  return {
    title,
    itemsCount,
    isActive,
  };
}
